export const VITE_EXTERNAL_API_HOST = import.meta.env.VITE_EXTERNAL_API_HOST || 'http://localhost:8000';

export const API_AUTH_LOGIN_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/auth/login`;
export const API_AUTH_PROFILE_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/auth/profile`;
export const API_AUTH_API_TOKEN_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/auth/api-token`;
export const API_AUTH_LANGUAGE_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/auth/language`;
export const API_PREDICT_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/predict`;
export const API_GET_INFERENCE_RESULTS_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/inference_results`;
export const API_GET_INFERENCE_RESULT_HIGHLIGHTS_ENDPOINT = `${API_GET_INFERENCE_RESULTS_ENDPOINT}/highlights`;
export const API_RERUN_INFERENCE_RESULTS_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/inference_results/rerun`;
export const API_GET_CSV_REPORT_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/reports/csv`;
export const API_CENTRIFUGE_REPORTS_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/reports/centrifuge-performance`;
export const API_CENTRIFUGE_REPORT_HIGHLIGHTS_ENDPOINT = `${API_CENTRIFUGE_REPORTS_ENDPOINT}/highlights`;
export const API_CENTRIFUGE_REPORT_DEFAULTS_ENDPOINT = `${API_CENTRIFUGE_REPORTS_ENDPOINT}/defaults`;
export const API_GET_RIGS_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/rigs`;
export const API_GET_RIGS_COUNT_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/rigs/count`;
export const API_GET_WELLS_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/wells`;
export const API_GET_WELLS_COUNT_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/wells/count`;
export const API_GET_CATALOG_TREE_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/catalog/tree`;
export const API_GET_SAMPLE_SOURCES_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/sample_sources`;
export const API_GET_IMPORT_FILES_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/import_files`;
export const API_GET_IMPORT_FILE_HIGHLIGHTS_ENDPOINT = `${API_GET_IMPORT_FILES_ENDPOINT}/highlights`;
export const API_COMPANY_SETTINGS_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/company-settings`;
export const API_LATEST_DESKTOP_APP_RELEASE_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/desktop-app/releases/latest`;

export function createApiGetPdfReportEndpoint(id: number): string {
  return `${VITE_EXTERNAL_API_HOST}/reports/` + id + '/pdf';
}

export function createApiGetImportFileEndpoint(id: number): string {
  return `${VITE_EXTERNAL_API_HOST}/import_files/${id}/download`;
}

export function createApiGetCalibrationEndpoint(rigId: number): string {
  return `${VITE_EXTERNAL_API_HOST}/rigs/${rigId}/calibration`;
}

export function createApiGetCentrifugeReportEndpoint(runUuid: string): string {
  return `${API_CENTRIFUGE_REPORTS_ENDPOINT}/${runUuid}`;
}

export function createApiGetCentrifugeReportPdfEndpoint(runUuid: string): string {
  return `${createApiGetCentrifugeReportEndpoint(runUuid)}/pdf`;
}

export function createApiPutCalibrationEndpoint(rigId: number): string {
  return `${VITE_EXTERNAL_API_HOST}/rigs/${rigId}/calibration`;
}

export const API_WELL_RETORT_HISTORY_ENDPOINT = `${VITE_EXTERNAL_API_HOST}/well_retort_history`;

export function createApiDeleteRetortHistoryEndpoint(id: number): string {
  return `${VITE_EXTERNAL_API_HOST}/well_retort_history/${id}`;
}
